import { v4 as uuidv4 } from "uuid";

export const MAX_OTHER_IMAGES = 10;
export const MAX_FLOOR_PLANS = 3;

export function listingImageKey(item: any) {
  return typeof item === "string" ? item : item?.id;
}

export function listingImageSrc(item: any) {
  if (item?.pic) return URL.createObjectURL(item.pic);
  return item;
}

export function removeListingImage(list: any[], key: string) {
  return (list || []).filter((item) => listingImageKey(item) !== key);
}

export function storedListingImageUrls(list: any[]) {
  return (list || []).filter((item): item is string => typeof item === "string");
}

export function appendListingFiles(existing: any[], files: FileList | File[], max: number) {
  const remaining = Math.max(0, max - (existing?.length || 0));
  const next = [];
  const count = Math.min(files.length, remaining);

  for (let i = 0; i < count; i++) {
    next.push({ id: `${uuidv4()}`, pic: files[i] });
  }

  return [...(existing || []), ...next];
}
